import { REM_BASE } from '../styles/button-radii';

/**
 * Web: returns the constant REM base (16). Browser scales rem-based tokens
 * automatically via `html { font-size }` + OS text-size + page zoom, so no
 * runtime work is needed at this layer.
 *
 * Native counterpart lives in `./useResponsiveRem.native.ts` and computes
 * a width-aware + accessibility-aware effective rem.
 */
export function useResponsiveRem(): number {
  return REM_BASE;
}

/** Companion: returns 1 on web (CSS rem already handles it). */
export function useResponsiveScale(): number {
  return 1;
}
